/**
 * @generated SignedSource<<64d57d3cd2d73f9138c323f02351b4c9>>
 * @relayHash 6301b50d1b4067b343901d9a540c988b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6301b50d1b4067b343901d9a540c988b

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Ch_createConsultationReportInput = {
  anamnesis: string;
  diagnosisCode: string;
  healthcareProviderId: string;
  isAiContentModified: boolean;
  isAiGenerated: boolean;
  language: Language;
  patientId: string;
  progressNoteId: string;
  recommendedTreatment: string;
};
export type useCreateConsultationReportMutation$variables = {
  input: Ch_createConsultationReportInput;
};
export type useCreateConsultationReportMutation$data = {
  readonly ch_createConsultationReport: {
    readonly ch_ConsultationReport: {
      readonly anamnesis: string;
      readonly concludedAt: string | null;
      readonly concludedBy: string | null;
      readonly createdAt: string;
      readonly createdBy: string;
      readonly diagnosisCode: string;
      readonly fileId: string | null;
      readonly fileMetadata: {
        readonly documentType: string;
        readonly extension: string;
        readonly lengthInKilobytes: number;
      } | null;
      readonly healthcareProviderId: string;
      readonly id: string;
      readonly isAiContentModified: boolean;
      readonly isAiGenerated: boolean;
      readonly language: Language;
      readonly patientId: string;
      readonly progressNoteId: string;
      readonly recommendedTreatment: string;
      readonly signedAt: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useCreateConsultationReportMutation = {
  response: useCreateConsultationReportMutation$data;
  variables: useCreateConsultationReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ConsultationReport",
  "kind": "LinkedField",
  "name": "ch_ConsultationReport",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "healthcareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anamnesis",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommendedTreatment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAiGenerated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAiContentModified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "PatientIdIsRequired",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "DocumentAlreadyExists",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "FieldLengthInvalid",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "ConsultationReportCareProviderNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateConsultationReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createConsultationReportPayload",
        "kind": "LinkedField",
        "name": "ch_createConsultationReport",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCreateConsultationReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createConsultationReportPayload",
        "kind": "LinkedField",
        "name": "ch_createConsultationReport",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6301b50d1b4067b343901d9a540c988b",
    "metadata": {},
    "name": "useCreateConsultationReportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "846ce6fef426e10afb416ac771537dfe";

export default node;
